export const news = {
  hero: {
    title: 'Habari na Hadithi',
    subtitle: 'Baki umejulishwa kuhusu ripoti zetu za hivi karibuni kutoka uwanjani, hadithi za mafanikio, na matangazo kutoka ardhini nchini Jamhuri ya Kidemokrasia ya Kongo',
  },
  featured: {
    badge: 'Hadithi Iliyoangaziwa',
    fieldReporter: 'Mwandishi wa Uwanja',
    readFullStory: 'Soma Hadithi Kamili',
  },
  categories: {
    all: 'Zote',
    fieldUpdates: 'Masasisho ya Uwanja',
    successStories: 'Hadithi za Mafanikio',
    announcements: 'Matangazo',
  },
  card: {
    readMore: 'Soma Zaidi',
  },
  empty: {
    message: 'Hakuna makala yaliyopatikana katika jamii hii',
  },
};
